
import axios from 'axios'
import VueCookies from 'vue-cookies'

export default {
  getTeacherReport (data) {
    // limit
    const limit = data.data.limit ? '&limit=' + data.data.limit : ''
    // pagination
    const page = data.data.page ? data.data.page : 1
    const dateFrom = data.data.date_from ? data.data.date_from : ''
    const dateTo = data.data.date_to ? data.data.date_to : ''
    const teacherId = data.data.teacher_id ? data.data.teacher_id : ''
    return axios.get(process.env.API_ENDPOINT + '/report/teachers?teacher_id=' + teacherId + '&date_from=' + dateFrom + '&date_to=' + dateTo + '&token=' + VueCookies.get('token') + '&page=' + page + limit)
  },
  getStudentReport (data) {
    // limit
    const limit = data.data.limit ? '&limit=' + data.data.limit : ''
    // pagination
    const page = data.data.page ? data.data.page : 1
    const dateFrom = data.data.date_from ? data.data.date_from : ''
    const dateTo = data.data.date_to ? data.data.date_to : ''
    const status = data.data.status ? data.data.status : ''
    const studentID = data.data.student_id ? data.data.student_id : ''
    return axios.get(process.env.API_ENDPOINT + '/report/students?student_id=' + studentID + '&date_from=' + dateFrom + '&date_to=' + dateTo + '&status=' + status + '&token=' + VueCookies.get('token') + '&page=' + page + limit)
  },
  getTeacherSalary (data) {
    // limit
    const limit = data.limit ? '&limit=' + data.limit : ''
    // pagination
    const page = data.page ? data.page : 1
    return axios.get(process.env.API_ENDPOINT + '/teacher-salary/get-classes?teacher_id=' + data.teacher_id + '&date_from=' + data.date_from + '&date_to=' + data.date_to + '&token=' + VueCookies.get('token') + '&page=' + page + limit)
  },
  createSalary (data) {
    return axios.post(process.env.API_ENDPOINT + '/teacher-salary?token=' + VueCookies.get('token'), data)
  },
  editTeacherSalary (data, id) {
    return axios.post(process.env.API_ENDPOINT + '/teacher-salary/' + id + '?token=' + VueCookies.get('token'), data)
  },
  getTeacherSalaries (data) {
    // limit
    const limit = data.limit ? '&limit=' + data.limit : ''
    // pagination
    const page = data.page ? data.page : 1
    // filters
    const teacherId = (data.teacher_id !== '') ? '&teacher_id=' + data.teacher_id : ''
    const dateFrom = (data.date_from !== '') ? '&date_from=' + data.date_from : ''
    const dateTo = (data.date_to !== '') ? '&date_to=' + data.date_to : ''

    return axios.get(process.env.API_ENDPOINT + '/teacher-salary?token=' + VueCookies.get('token') + '&page=' + page + limit + teacherId + dateFrom + dateTo)
  },
  getTeacherSalariesPerID (id) {
    return axios.get(process.env.API_ENDPOINT + '/teacher-salary/' + id + '?token=' + VueCookies.get('token'))
  },
  getRevenue (data) {
    const dateFrom = data.data.date_from ? data.data.date_from : ''
    const dateTo = data.data.date_to ? data.data.date_to : ''
    const csv = data.data.export ? data.data.export : 0
    // limit
    const limit = data.data.limit ? '&limit=' + data.data.limit : ''
    // pagination
    const page = data.data.page ? data.data.page : 1

    return axios.get(process.env.API_ENDPOINT + '/report/revenues?token=' + VueCookies.get('token') + '&date_from=' + dateFrom + '&date_to=' + dateTo + '&export=' + csv + limit + '&page=' + page)
  },
  getExpenses (data) {
    const dateFrom = data.data.date_from ? data.data.date_from : ''
    const dateTo = data.data.date_to ? data.data.date_to : ''
    const csv = data.data.export ? data.data.export : 0
    // limit
    const limit = data.data.limit ? '&limit=' + data.data.limit : ''
    // pagination
    const page = data.data.page ? data.data.page : 1
    return axios.get(process.env.API_ENDPOINT + '/report/expenses?token=' + VueCookies.get('token') + '&date_from=' + dateFrom + '&date_to=' + dateTo + '&export=' + csv + limit + '&page=' + page)
  }
}



// WEBPACK FOOTER //
// ./src/store/api/reports.js